import { useToastStore } from '../store/toastStore';

/** Bottom-centre stack of auto-dismissing toast notifications. */
export function ToastHost(): React.ReactElement | null {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismissToast);
  if (toasts.length === 0) return null;
  return (
    <div className="toast-host">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast-${t.kind}`}
          role="status"
          onClick={() => dismiss(t.id)}
          title="Dismiss"
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
